import { IMetricDeprecatedService } from '@contact/upgrade';

// default rate formatter function
export function rateFormatFunc(metric: IMetricDeprecatedService, value): string {
  if (value === 0 && !metric.isChannelSubscribed()) {
    return '-';
  }
  return Math.round(value) + '%';
}

// default formatter function
export function valueFunc(metric: IMetricDeprecatedService, value) {
  if (value === 0 && !metric.isChannelSubscribed()) {
    return '-';
  }
  return value;
}

// default color value function
export function defaultColorFunc(): number {
  return 100;
}

export function totalAgents(metrics) {
  return (
    metrics.SUM_CSR_WORKING_DOMAIN_NOW +
    metrics.SUM_CSR_TASK_DOMAIN_NOW +
    metrics.SUM_CSR_NOT_WORKING_DOMAIN_NOW +
    metrics.SUM_CSR_AVAILABLE_DOMAIN_NOW
  );
}

export function totalContacts(metrics) {
  return metrics.SUM_CTT_SUCCESS_DOMAIN + metrics.SUM_CTT_GAVE_UP_DOMAIN + metrics.SUM_CTT_DISSUADED_DOMAIN;
}

export function computeOccupationRate(metrics) {
  return ((metrics.SUM_CSR_WORKING_DOMAIN_NOW + metrics.SUM_CSR_TASK_DOMAIN_NOW) / Math.max(1, totalAgents(metrics))) * 100;
}

export function computeHandledRate(metrics) {
  return (metrics.SUM_CTT_SUCCESS_DOMAIN / Math.max(1, totalContacts(metrics))) * 100;
}

export function computeAgentRate(metrics, metricName) {
  return (metrics[metricName] / Math.max(1, totalAgents(metrics))) * 100;
}

export function computeContactRate(metrics, metricName) {
  return (metrics[metricName] / Math.max(1, totalContacts(metrics))) * 100;
}

export function computeAvgProcessTime(metrics) {
  return metrics.TS_CTT_CALL_DURATION_DOMAIN / Math.max(1, metrics.SUM_CTT_SUCCESS_DOMAIN);
}
